export default function createLayerToggle(toggleableLayerIds, map) {
  return toggleableLayerIds.map((lay) => {
    return (
      <button
        className='map-layer-button-not-active'
        value={lay}
        key={lay}
        onClick={function (e) {
          let clickedLayer = e.currentTarget.value;
          e.preventDefault();
          e.stopPropagation();

          let visibility = map.getLayoutProperty(clickedLayer, 'visibility');

          // toggle layer visibility by changing the layout object's visibility property
          if (visibility === 'visible') {
            map.setLayoutProperty(clickedLayer, 'visibility', 'none');
            e.currentTarget.className = 'map-layer-button-not-active'; // change menu items color
          } else {
            e.currentTarget.className = 'map-layer-button-active'; // change menu items color
            map.setLayoutProperty(clickedLayer, 'visibility', 'visible');
          }
        }}
      >
        {lay}
      </button>
    );
  });
}
